import qs from "qs";
import { _axios } from "./config";
import { IS_LOCAL_ENV } from "../App";
import Notification from "../components/ui-elements/Notification";

export const getUsers = async () => {
  try {
    const { data } = await _axios.get(`/api/users?limit=0&depth=1`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const uploadUserImage = async (props) => {
  const formData = new FormData();
  formData.append("alt", props.alt);
  formData.append("file", props.file);

  try {
    const { data } = await _axios.post(`/api/userPhotos`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
    return data.doc;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const deleteUserImage = async (id) => {
  try {
    const { data } = await _axios.delete(`/api/userPhotos/${id}`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const updateUser = async (id, props) => {
  try {
    const { data } = await _axios.put(`/api/users/${id}`, { ...props });
    return data.doc;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const deleteUser = async (id) => {
  try {
    const { data } = await _axios.delete(`/api/users/${id}`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const createUser = async (props) => { //register needs a password
  try {
    const { data } = await _axios.post(`/api/users`, { ...props });
    return data.doc;
  }
  catch (err) {
    showAlert(err.response.data.errors)
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

const showAlert = (errArray) => {
  errArray.map((err) => {
    Notification({
      title: "Error",
      text: err?.message || "Algo salió mal...",
      type: "Error",
    })
  })
}